import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon

  useEffect(() => {
    const token = localStorage.getItem("ant_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("ant_token");
        setUser(null);
      });
  }, []);

  const persist = (data) => {
    localStorage.setItem("ant_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    return persist(res.data);
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    if (res.data && res.data.access_token) return persist(res.data);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("ant_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, updateUser: setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
